import {
    Phone,
    Mail,
    MapPin,
    Clock,
    MessageCircle,
    ArrowUpRight,
} from "lucide-react";
import { BRAND } from "@/data/content";

const InfoRow = ({ icon: Icon, label, value, href, testid }) => {
    const Wrapper = href ? "a" : "div";
    const props = href
        ? {
              href,
              target: href.startsWith("http") ? "_blank" : undefined,
              rel: href.startsWith("http") ? "noopener noreferrer" : undefined,
          }
        : {};
    return (
        <Wrapper
            {...props}
            data-testid={testid}
            className="group flex items-start gap-4 p-5 rounded-2xl bg-white border border-[#0055FF]/10 hover:border-[#0055FF]/40 transition-all"
        >
            <div className="w-11 h-11 rounded-xl bg-[#E5EFFF] text-[#0055FF] flex items-center justify-center shrink-0 group-hover:bg-[#0055FF] group-hover:text-white transition-colors">
                <Icon className="w-5 h-5" strokeWidth={2.2} />
            </div>
            <div className="flex-1 min-w-0">
                <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#4A6177]">
                    {label}
                </div>
                <div className="mt-1 text-base font-bold text-[#0B1B2B] break-words">
                    {value}
                </div>
            </div>
            {href && (
                <ArrowUpRight className="w-4 h-4 text-[#4A6177] group-hover:text-[#0055FF] group-hover:rotate-12 transition-all shrink-0" />
            )}
        </Wrapper>
    );
};

export const Contact = () => {
    return (
        <section
            id="iletisim"
            data-testid="contact-section"
            className="py-24 sm:py-32 bg-[#F4F8FB] relative overflow-hidden"
        >
            <div className="onx-container relative">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
                    {/* Left side */}
                    <div className="lg:col-span-5">
                        <div className="onx-overline mb-4">İletişim</div>
                        <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-[-0.03em] leading-[0.95] text-[#0B1B2B]">
                            Bir mesaj uzakta. <br />
                            <span className="text-[#0055FF]">
                                Yanıt hızlı.
                            </span>
                        </h2>
                        <p className="mt-5 text-base sm:text-lg text-[#4A6177] leading-relaxed max-w-md">
                            Mekânınız, ihtiyacınız ve tercih ettiğiniz saat
                            aralığını WhatsApp'tan yazın; en kısa sürede net
                            bir fiyat teklifi ile dönüyoruz.
                        </p>

                        <a
                            href={BRAND.whatsapp}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="contact-cta-whatsapp"
                            className="mt-8 inline-flex w-full sm:w-auto items-center justify-center gap-3 px-7 py-4 rounded-full bg-[#25D366] text-white font-bold tracking-wide hover:bg-[#1FAA52] hover:-translate-y-0.5 transition-all shadow-[0_15px_40px_-10px_rgba(37,211,102,0.55)]"
                        >
                            <MessageCircle className="w-5 h-5" />
                            WhatsApp ile İletişime Geç
                        </a>
                    </div>

                    {/* Right side: info cards */}
                    <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <InfoRow
                            icon={Phone}
                            label="Telefon"
                            value={BRAND.phoneDisplay}
                            href={`tel:+${BRAND.phoneRaw}`}
                            testid="contact-info-phone"
                        />
                        <InfoRow
                            icon={MessageCircle}
                            label="WhatsApp"
                            value={BRAND.phoneDisplay}
                            href={BRAND.whatsapp}
                            testid="contact-info-whatsapp"
                        />
                        <InfoRow
                            icon={Mail}
                            label="E-posta"
                            value={BRAND.email}
                            href={`mailto:${BRAND.email}`}
                            testid="contact-info-email"
                        />
                        <InfoRow
                            icon={Clock}
                            label="Çalışma Saatleri"
                            value={BRAND.hours}
                            testid="contact-info-hours"
                        />
                        <div className="sm:col-span-2">
                            <InfoRow
                                icon={MapPin}
                                label="Konum"
                                value={BRAND.locationLong}
                                testid="contact-info-location"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
